import React from 'react'

const Contact = () => {
    return (
        <div className='flex gap-2 text-primary'>
            <a href="https://www.youtube.com/@CoolProgrammingProjectsRJ" target='_blank' className='hover:underline'>Youtube</a>
            <a href="https://www.linkedin.com/in/rishabh-jain-873a29243/" target='_blank' className='hover:underline'>LinkedIn</a>
            <a href="https://github.com/Rishabh-Jain-Rj" target='_blank' className='hover:underline'>Github</a>
        </div>
    )
}

export default Contact